import { CustomerProtocolData } from 'pages/OpenProtocol/CustomerData/interface';
import React, {
  createContext,
  useContext,
  useState,
} from 'react';

import { CustomerDataContextProviderProps, CustomerDataContextType } from './interface';

const CustomerDataContext = createContext({} as CustomerDataContextType);

export function CustomerDataContextProvider({ children }: CustomerDataContextProviderProps) {

  const customerProtocolInitial = {
    identifier: "",
    documentNumber: "",
    useElectronicBillLading: false
  };

  const [customerProtocol, setCustomerProtocol] = useState<CustomerProtocolData>(customerProtocolInitial);

  const addCustomerProtocol = (company: CustomerProtocolData) => {
    const customerData = {
      identifier: company?.identifier,
      documentNumber: company?.documentNumber,
      useElectronicBillLading: company?.useElectronicBillLading
    };

    setCustomerProtocol(customerData);
  };

  return (
    <CustomerDataContext.Provider
      value={{
        addCustomerProtocol: (company) => addCustomerProtocol(company),
        customerProtocol
      }}
    >
      {children}
    </CustomerDataContext.Provider>
  );
}

export const useCustomerDataContext = () => {
  return useContext(CustomerDataContext);
};